import {
  Box,
  Button,
  Grid,
  GridItem,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import SignInVector from "../assets/images/signin-vector.png";
import { Formik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { IoMdLock } from "react-icons/io";
import { useDispatch } from "react-redux";
import {
  checkResetPage,
  fogotPassword,
  resetPassword,
  sendOTP,
  signIn,
} from "../api";
import { verifyOTP } from "../redux/auth/AuthSlice";
import { useTimer } from "react-timer-hook";
import errorImage from "../assets/images/error-image.png";

function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPasswordVisble, setIsPasswordVisble] = useState(false);
  const [isRePasswordVisble, setIsRePasswordVisble] = useState(false);
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();

 

  const checkToken = async () => {
    let response = await checkResetPage(id);
    setStatus(response?.message);
  };

  useEffect(() => {
    checkToken();
  }, [status]);

  return (
    <Box>
      {status === "active" ? (
        <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"}>
          <GridItem colSpan={1}>
            <Box bg={"#fff"} h={"calc(100vh - 0px)"} marginTop="-1rem">
              <Box paddingLeft={"2rem"} paddingTop="6rem">
                <Text color={" #464C64"} fontSize="md"></Text>
                <Box
                  display={"flex"}
                  justifyContent="right"
                  marginLeft={"-5rem"}
                >
                  <Image h="493px" src={SignInVector} />
                </Box>
              </Box>
            </Box>
          </GridItem>
          <GridItem>
            <Box background={"#EDF3F8"} paddingTop="3rem">
              <Box marginLeft={"4rem"}>
                <Text
                  color={"#141D43"}
                  fontSize="4xl"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Reset Password
                </Text>
                <Box marginTop={"3rem"}>
                  <Box w="60%">
                    <Formik
                      initialValues={{
                        password: "",
                        rePass: "",
                      }}
                      onSubmit={async (values, { resetForm }) => {
                        //   localStorage.setItem("user-email", values.email);

                        delete values.rePass;

                        let response = await resetPassword(
                          
                          values,
                          id,
                          setIsLoading
                        );
                        if (response.status) {
                          resetForm();
                          navigate("/signin");

                        }
                      }}
                      validationSchema={Yup.object().shape({
                        password: Yup.string().required(
                          "Please enter your password"
                        ),
                        rePass: Yup.string()
                          .required("Please re-enter your password")
                          .oneOf(
                            [Yup.ref("password"), null],
                            "Passwords must match"
                          ),
                      })}
                    >
                      {(props) => {
                        const {
                          values,
                          touched,
                          errors,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          resetForm,
                        } = props;
                        return (
                          <>
                            <Box marginTop={"10px"} w="80%" position="relative">
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                New Password
                              </Text>
                              <Box>
                                <Input
                                  type={isPasswordVisble ? "text" : "password"}
                                  color={"#141D43"}
                                  marginTop="10px"
                                  id="password"
                                  bg={"#fff"}
                                  zIndex="10"
                                  placeholder="Password"
                                  value={values.password}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setPassword(values.password);
                                  }}
                                  onBlur={handleBlur}
                                  border={"none"}
                                  fontSize={"14px"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "  #B8DEF8",
                                    fontSize: "14px",
                                  }}
                                  _focusVisible={
                                    errors.password && touched.password
                                      ? {
                                          border: "1px solid red !important",
                                        }
                                      : { border: "1px solid #3958DC" }
                                  }
                                />

                                <Box
                                  onClick={() => {
                                    if (values.password?.length <= 0) return;
                                    setIsPasswordVisble((prev) => !prev);
                                  }}
                                  style={{
                                    top:
                                      errors.password && touched.password
                                        ? "40%"
                                        : "58%",
                                    opacity:
                                      values.password?.length > 0 ? 1 : 0.4,
                                    cursor:
                                      values.password?.length > 0
                                        ? "pointer"
                                        : "not-allowed",
                                    position: "absolute",
                                  }}
                                  cursor="pointer"
                                  right={"10px"}
                                  zIndex="10"
                                >
                                  {!isPasswordVisble ? (
                                    <AiOutlineEye color={"#52BBFF"} size={24} />
                                  ) : (
                                    <AiOutlineEyeInvisible
                                      color="#52BBFF"
                                      size={24}
                                    />
                                  )}
                                </Box>
                                {errors.password && touched.password && (
                                  <Box color="red.500" marginTop={"10px"}>
                                    {errors.password}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                            <Box marginTop={"10px"} w="80%" position="relative">
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                                marginTop={"1rem"}
                              >
                                Re-Enter New Password
                              </Text>
                              <Box>
                                <Input
                                  type={
                                    isRePasswordVisble ? "text" : "password"
                                  }
                                  color={"#141D43"}
                                  marginTop="10px"
                                  id="rePass"
                                  bg={"#fff"}
                                  zIndex="10"
                                  position="relative"
                                  placeholder="Re-enter Password"
                                  value={values.rePass}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  border={"none"}
                                  fontSize={"14px"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "  #B8DEF8",
                                    fontSize: "14px",
                                  }}
                                  _focusVisible={
                                    errors.rePass && touched.rePass
                                      ? {
                                          border: "1px solid red !important",
                                        }
                                      : { border: "1px solid #3958DC" }
                                  }
                                />

                                <Box
                                  onClick={() => {
                                    if (values.rePass?.length <= 0) return;
                                    setIsRePasswordVisble((prev) => !prev);
                                  }}
                                  style={{
                                    top:
                                      errors.rePass && touched.rePass
                                        ? "40%"
                                        : "58%",
                                    opacity:
                                      values.rePass?.length > 0 ? 1 : 0.4,
                                    cursor:
                                      values.rePass?.length > 0
                                        ? "pointer"
                                        : "not-allowed",
                                    position: "absolute",
                                  }}
                                  cursor="pointer"
                                  right={"10px"}
                                  zIndex="10"
                                >
                                  {!isRePasswordVisble ? (
                                    <AiOutlineEye color={"#52BBFF"} size={24} />
                                  ) : (
                                    <AiOutlineEyeInvisible
                                      color="#52BBFF"
                                      size={24}
                                    />
                                  )}
                                </Box>
                                {errors.rePass && touched.rePass && (
                                  <Box color="red.500" marginTop={"10px"}>
                                    {errors.rePass}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                            <Box marginTop={"2rem"} w="80%">
                              <Button
                                type="submit"
                                disabled={
                                  isLoading || status === "expired" ? true : ""
                                }
                                onClick={() => handleSubmit()}
                                width={"100%"}
                                bg="#52BBFF"
                                color={"#fff"}
                                _hover={{ bg: "#52BBFF" }}
                              >
                                Reset Password
                              </Button>
                            </Box>
                          </>
                        );
                      }}
                    </Formik>
                  </Box>
                </Box>
              </Box>
            </Box>
          </GridItem>
        </Grid>
      ) : (
        <Box
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          marginTop="5rem"
        >
          <Box display={"block"}>
            <Box>
              <Image src={errorImage} width="600px" height={"400px"} />
            </Box>
            <Box>
              <Text
                color={"#514898"}
                fontSize="5xl"
                fontWeight={"800"}
                fontFamily={"font.roboto"}
                display={"flex"}
                justifyContent="center"
              >
                ERROR 404
              </Text>
              <Text
                color={"#9552FF"}
                fontSize="xl"
                fontWeight={"400"}
                fontFamily={"font.roboto"}
                display={"flex"}
                justifyContent="center"
              >
                Page you’re Looking doesn’t Exists
              </Text>
              <Box display={"flex"} justifyContent="center" marginTop={"2rem"}>
                <Button
                  w="150px"
                  bg="#4788D6"
                  color={"#fff"}
                  _hover={{ bg: "#52BBFF" }}
                  onClick={() => navigate("/signin")}
                >
                  Back
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default ResetPassword;
